import { updateEventsSite } from "stores/slice/bogus/events/const";

const eventsConfig = {
  // org get events
  // API/falcon/organizations => /ents/{entId}/orgs/{orgId}/events
  "/ents/:entId/orgs/:orgId/events.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/events",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "events",
  },
  // API/falcon/organizations => /orgs/{orgId}/events (standalone)
  "/orgs/:orgId/events.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/events",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "events",
  },
  // site get events
  // API/falcon/site => /ents/{entId}/orgs/{orgId}/sites/{siteId}/events
  "/ents/:entId/orgs/:orgId/sites/:siteId/events.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/events",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "events",
  },
  // API/falcon/site => /orgs/{orgId}/sites/{siteId}/events (standalone)
  "/orgs/:orgId/sites/:siteId/events.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/events",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "events",
  },
  // org update events
  // API/falcon/organizations => /ents/{entId}/orgs/{orgId}/events/acknowledge
  "/ents/:entId/orgs/:orgId/events/acknowledge.update": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/events/acknowledge",
    restful: true,
    method: "update",
    buildParams: null,
    action: updateEventsSite,
    mockSelector: "events.updateData",
  },
  // API/falcon/organizations => /orgs/{orgId}/events/acknowledge (standalone)
  "/orgs/:orgId/events/acknowledge.update": {
    protocol: "ws",
    resource: "/orgs/:orgId/events/acknowledge",
    restful: true,
    method: "update",
    buildParams: null,
    action: updateEventsSite,
    mockSelector: "events.updateData",
  },
  // site update events
  // API/falcon/site => /ents/{entId}/orgs/{orgId}/sites/{siteId}/events/acknowledge
  "/ents/:entId/orgs/:orgId/sites/:siteId/events/acknowledge.update": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/events/acknowledge",
    restful: true,
    method: "update",
    buildParams: null,
    action: updateEventsSite,
    mockSelector: "events.updateData",
  },
  // API/falcon/site => /orgs/{orgId}/sites/{siteId}/events/acknowledge (standalone)
  "/orgs/:orgId/sites/:siteId/events/acknowledge.update": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/events/acknowledge",
    restful: true,
    method: "update",
    buildParams: null,
    action: updateEventsSite,
    mockSelector: "events.updateData",
  },
};

export default eventsConfig;
